import React, { useContext }  from 'react'
import ProductType from './ProductType'
import { AppContext } from '../App'

export default function ProductTypeList() {
   const { loading } = useContext(AppContext)
   const { productTypes } = useContext(AppContext)
   return (
      <div className="panel panel-primary">
         <div className="panel-heading">
            <h4 className="panel-title text-center">Select Product Type</h4>
         </div>
         <div className="panel-body">
         {
            // Check to see if loading is active. If so, show loading component. Else show the product type list.
            (!loading && productTypes) && (
               productTypes.map(p => {
                  return (
                     <ProductType key={p.value} {...p} />
                  )
               })
            )
         }
         </div>
      </div>
   )
}


// WEBPACK FOOTER //
// ./src/components/ProductTypeList.js